import axios from 'axios';

export const htmlId: string = 'fixcenter-career-form';
export const formContainerHtmlId: string = 'UploadYourResumeHeader';
export const maxWidthDragAndDropFile: number = 500;
export const minHeightDragAndDropFile: number = 50;
export const uploadFileInfo: string = 'UPLOAD_FILE_INFO';
export const extensionFiles: string[] = ['.pdf'];

export function uploadResumeHeader(dto: FormData) {
    return axios.post(`FixcenterCareer/UploadResumeHeader`, dto);
}
